import React from "react";
import "../style/footerSection/footerSection.css";

const FooterSection = ({
  quickLinks = [],
  experiences = [],
  transportation = [],
  company = [],
  contacts = {},
  services = [],
}) => {
  return (
    <div className="footer-section">
      <div className="container">
        <div className="row no-gutters">
          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <div className="foot-head">Quick Links</div>
            {quickLinks.map((text, idx) => (
              <div className="foot-link" key={idx}>
                <a
                  href={`/${text
                    .toLowerCase()
                    .replace(/ /g, "-")}`}
                >
                  {text}
                </a>
              </div>
            ))}
          </div>

          {/* Experiences */}
          <div className="col-lg-4 col-md-6">
            <div className="foot-head">Experiences</div>
            {experiences.map((text, idx) => (
              <div className="foot-link" key={idx}>
                <a href="/experiences">{text}</a>
              </div>
            ))}
          </div>

          {/* Transportation */}
          <div className="col-lg-3 col-md-6">
            <div className="foot-head">Services</div>
            {services.map((text, idx) => (
              <div className="foot-link" key={idx}>
                <a href={`/services#${text.toLowerCase().split(' ')[0]}`}>{text}</a>
              </div>
            ))}
          </div>

          {/* Company Info */}
          <div className="col-lg-3 col-md-6">
            <div className="foot-head">Contact</div>
            {company.map((text, idx) => (
              <div className="foot-link" key={idx}>
                <a href="#">{text}</a>
              </div>
            ))}

            <div className="border-top1"></div>
            {contacts?.emails?.map((items) => {
              return (
                <div className="foot-link mt-3">
                  <strong>{items.type}:</strong>
                  <br />
                  <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                  <a href={`mailto:${items.email}`}>{items.email}</a>
                </div>
              );
            })}
            {contacts?.mobile_number_list?.map((items) => {
              return (
                <div className="foot-link mt-3">
                  <strong>{items.type}:</strong>
                  <br />
                  <i className="fa fa-phone" aria-hidden="true"></i>{" "}
                  <a href={`tel:${items.mobile}`}>{items.mobile}</a>
                </div>
              );
            })}
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright mt-4">
          <div>{`Copyright © ${new Date().getFullYear()} Blue Diamond Voyage, All rights reserved.`}</div>
          <div className="foot-social">
            {contacts?.social_link?.map((items) => {
              // return (
              switch (items.type) {
                case "facebook":
                  return (
                    <div
                      onClick={() => {
                        window.open(items.url, "_blank");
                      }}
                      className="pointer-cursor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa fa-facebook-square"
                        aria-hidden="true"
                      ></i>
                    </div>
                  );
                case "twitter":
                  return (
                    <div
                      onClick={() => {
                        window.open(items.url, "_blank");
                      }}
                      className="pointer-cursor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-twitter" aria-hidden="true"></i>
                    </div>
                  );
                case "linkedin":
                  return (
                    <div
                      onClick={() => {
                        window.open(items.url, "_blank");
                      }}
                      className="pointer-cursor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-linkedin" aria-hidden="true"></i>
                    </div>
                  );
                case "instagram":
                  return (
                    <div
                      onClick={() => {
                        window.open(items.url, "_blank");
                      }}
                      className="pointer-cursor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-instagram" aria-hidden="true"></i>
                    </div>
                  );
                case "youtube":
                  return (
                    <div
                      onClick={() => {
                        window.open(items.url, "_blank");
                      }}
                      className="pointer-cursor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-youtube-play" aria-hidden="true"></i>
                    </div>
                  );
                default:
                  return null;
              }
              // )
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
